import MainLayout from '../components/photographer/MainLayout'
import Dashboard from '../components/photographer/Dashboard'
import Request from '../components/photographer/Request'
import BookingUpComingEvent from '../components/photographer/BookingUpComingEvent'
import BookingNeedToUpload from '../components/photographer/BookingNeedToUpload'
import Message from '../components/photographer/Message'
import MessageDetail from '../components/photographer/MessageDetail'
import ServiceLists from '../components/photographer/ServiceLists'
import ServiceAdd from '../components/photographer/ServiceAdd'
import ServiceArea from '../components/photographer/ServiceArea'
import AvailabilityTime from '../components/photographer/AvailabilityTime'
import AvailabilityHoliday from '../components/photographer/AvailabilityHoliday'
import AccountProfile from '../components/photographer/AccountProfile'
import AccountPayment from '../components/photographer/AccountPayment'

export default {
  path: '/photographer',
  component: MainLayout,
  meta: {
    login: true,
    loginType: 'photographer'
  },
  children: [
    {
      path: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'request',
      component: Request,
      meta: {
        title: 'Request',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'booking',
      component: BookingUpComingEvent,
      meta: {
        title: 'BOOKING',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'booking/upload',
      component: BookingNeedToUpload,
      meta: {
        title: 'NEED TO UPLOAD',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'message',
      component: Message,
      meta: {
        title: 'MESSAGE',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'message/:serviceId',
      component: MessageDetail,
      meta: {
        title: 'MESSAGE Detail',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'service',
      component: ServiceLists,
      meta: {
        title: 'SERVICE',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'service/add',
      component: ServiceAdd,
      meta: {
        title: 'SERVICE ADD',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'service/edit',
      component: ServiceAdd,
      meta: {
        title: 'SERVICE ADD',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'service/area',
      component: ServiceArea,
      meta: {
        title: 'SERVICE AREA',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'availability',
      component: AvailabilityTime,
      meta: {
        title: 'AVAILABILITY TIME',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'availability/holiday',
      component: AvailabilityHoliday,
      meta: {
        title: 'AVAILABILITY HOLIDAY',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'account',
      component: AccountProfile,
      meta: {
        title: 'ACCOUNT PROFILE',
        login: true,
        loginType: 'photographer'
      }
    },
    {
      path: 'account/payment',
      component: AccountPayment,
      meta: {
        title: 'ACCOUNT PAYMENT',
        login: true,
        loginType: 'photographer'
      }
    }
  ]
}
